<template>
  <div class="photo-upload">
    <b-row class="align-items-center">
      <b-col cols="7">
        <div 
          class="pl-1 pr-1 upload-zone d-flex align-items-center justify-content-center"
          @dragover.prevent="onDragOver"
          @dragenter.prevent="onDragEnter"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="handleDrop"
          @click="triggerFileInput"
          :class="{ 'drag-over': isDragOver, 'no-border': oldPhoto || newPhoto }"
        >
          <input 
            type="file" 
            ref="fileInput"
            style="display:none"
            accept="image/png, image/jpeg" 
            @change="handleFileSelect"
          />
          <canvas v-if="newPhoto"
            class="image"
            id="photoUploadCanvas"
            ref="photoUploadCanvas"
            :width="photoCanvasWidth"
            :height="photoCanvasHeight"
          ></canvas>
          <img v-else-if="oldPhoto" class="image" :src="oldPhoto" />
          <button v-else class="framework-text-button-primary far fa-upload"></button>
        </div>
      </b-col>

      <b-col cols="2" class="d-flex">
        <button v-if="newPhoto" class="mr-5 framework-text-button-primary far fa-trash" @click="removeCanvas"></button>
        <button v-if="newPhoto" class="framework-text-button-primary far fa-save" @click="uploadSelectedFile"></button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import colors from "@/assets/scss/MotivateColors.scss";
import firebase from "firebase/app";

export default{
    name:"uploadImage",
    components: {},
    mixins: [],
    props: ['profilePicture', 'userUid'],
    data() {
        return {
            oldPhoto: null,
            newPhoto: null,
            isDragOver: false,
            placeholderUrl: "https://www.medtalks.nl/images/user-placeholder.jpg",
        }
    },
    computed: {
        getColors(){
            return colors;
        },
    },
    methods: {
        async removeCanvas() {
            this.newPhoto = null;
            this.$refs.fileInput.value = '';
        },
        onDragOver(event) {
            event.preventDefault();
            this.isDragOver = true;
        },
        onDragEnter(event) {
            event.preventDefault();
            this.isDragOver = true;
        },
        onDragLeave(event) {
            this.isDragOver = false;
        },
        handleDrop(event) {
            event.preventDefault();
            this.isDragOver = false;
            const file = event.dataTransfer.files[0];
            if (file) {
                this.newPhoto = file;
                console.log("Dropped file:", file.name);
                this.processFile(file)
            }
        },
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                if (!file.type.startsWith("image/")) {
                    alert("Only image files are allowed!");
                    return;
                }
                const allowedExtensions = ["jpg", "jpeg", "png"];
                const fileExtension = file.name.split(".").pop().toLowerCase();
                if (!allowedExtensions.includes(fileExtension)) {
                    alert("Invalid file type. Only JPG, PNG allowed.");
                    return;
                }

                this.newPhoto = file;
                console.log("Selected file:", file.name);
                this.processFile(file)
            }
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        processFile(file) {
            const self = this;
            const reader = new FileReader();

            reader.onload = (e) => {
                let img = new Image();
                img.onload = function () {
                    const fixedWidth = 220;
                    let multiplier = img.height / img.width;

                    self.photoCanvasWidth = fixedWidth;
                    self.photoCanvasHeight = multiplier * fixedWidth;

                    self.drawCanvasImage(
                        img,
                        self.photoCanvasWidth,
                        self.photoCanvasHeight
                    );
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        },
        drawCanvasImage(img, x, y) {
            console.log("canvas width: ", x);
            console.log("canvas height: ", y);

            const canvas = this.$refs.photoUploadCanvas;
            canvas.width = 220;
            canvas.height = 220;

            setTimeout(() => {
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                const offsetX = (canvas.width - x) / 2;
                const offsetY = (canvas.height - y) / 2;
                ctx.drawImage(img, offsetX, offsetY, x, y);
            }, 500);
        },
        async uploadSelectedFile(event) {
            event.preventDefault();

            const fileCanvas = this.$refs.photoUploadCanvas.toDataURL("image/jpeg");
            const storageRef = firebase
                .storage()
                .ref("users/" + this.userUid + "/profile.jpg");
            await storageRef
                .putString(fileCanvas, "data_url")
                .then(function () {
                    console.log("Uploaded succesfully");
                    $("#cameraModal").modal("hide");

                })
                .catch((error) => {
                });

            this.newPhoto = null
            await this.getProfilePicture();
            this.swalToastSuccess(this.$t("ui.saved"));
        },
        async getProfilePicture() {
            firebase
                .storage()
                .ref("users/" + this.userUid + "/profile.jpg")
                .getDownloadURL()
                .then((imgUrl) => {
                    this.oldPhoto = imgUrl;
                })
                .catch((error) => {
                    this.oldPhoto = "https://www.medtalks.nl/images/user-placeholder.jpg"
                });
        },
    },
    created() {
        this.oldPhoto = this.profilePicture
    },
    watch: {
        profilePicture: {
            deep: true,
            handler(newVal) {
                this.oldPhoto = newVal
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/desktop/ve-table-desktop.scss";
@import "@/assets/scss/components/desktop/frameworkButtonDesktop.scss";
@import "@/assets/scss/components/desktop/frameworkTextButtonDesktop.scss";
@import "@/assets/scss/components/desktop/frameworkModalDesktop.scss";
@import "@/assets/scss/_overwritesNewUi.scss";
.image-container {
    width: 100%;
    max-width: 300px; 
    height: 100px;
    aspect-ratio: 2 / 3;
}
.image:hover{
    box-shadow: 0 4px 12px rgba($ceruleanBlue, 0.3);
}
.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}
.upload-zone{
    width: 100%;
    height: 100px;
    display:flex;
    justify-content:center;
    align-items:center;
    border:2px dashed $cadetGrey;
    border-radius:8px;
    cursor:pointer;
}
.upload-zone:hover,
.upload-zone.drag-over{
    background: linear-gradient(135deg, $softGrey, $grey);
    border-color: $ceruleanBlue;
    box-shadow: 0 4px 12px rgba($ceruleanBlue, 0.3);
    color: $ceruleanBlue;
}
.upload-zone.no-border {
  border: none;
}
</style>